import { GeneralTerms } from "../general-terms/GeneralTerms"
import { useEffect, useState } from "react"
import { observer } from "mobx-react"
import { useStore } from "../../hooks"
import { Checkbox, FormControlLabel } from "@material-ui/core"
import { Elements, TextButton } from "@tfo/common"
import { useIntl } from 'react-intl'
import $http from "../../utils/$http"
import * as Common from '@tfo/common'
import { useHistory, useLocation } from "react-router-dom"

import './GeneralTermsApproval.scss'

const { Paragraph, Heading1 } = Elements

export const GeneralTermsApproval = observer(() => {
    const rootStore = useStore()
    const intl = useIntl()
    const [userHasApproved, setUserHasApproved] = useState(false)
    const history = useHistory()
    const { state } = useLocation<{ returnUrl: string }>()
    const cookie = Common.utils.getCookie()

    useEffect(() => {
        if (!cookie?.acceptedGeneralTerms) {
            rootStore.clientViewStore.activateLockedMode(true)
        }
    }, [])

    const handleAcceptGeneralTerms = async () => {
        $http.post<any>(`/general-terms/accept/${rootStore.userStore.userId}`)
            .then((response) => {
                Common.utils.updateAcceptedGeneralTermsTimeStamp(response)
                rootStore.clientViewStore.activateLockedMode(false)
                history.push(state?.returnUrl || "/start")
            }
            )
            .catch((error) => console.log(error))
    }

    return <div className="generalTermsApprovalContainer">
        <div className="approvalHeadingContainer">
            <Heading1>{intl.formatMessage({ id: 'common.generalTerms.heading' })}</Heading1>
            <Paragraph>{intl.formatMessage({ id: 'common.generalTerms.subheading1' })}</Paragraph>
            <br />
        </div>
        <GeneralTerms />
        <div className="approvalContainer">
            <div className="approvalWrapper">
                <div className="checkboxParagraphWrapper">
                    <FormControlLabel
                        control={<Checkbox checked={userHasApproved} onChange={() => setUserHasApproved(!userHasApproved)} className="checkbox" />}
                        label={intl.formatMessage({ id: 'common.generalTerms.approval' })} />
                </div>
                <TextButton
                    disabled={!userHasApproved}
                    className="button"
                    onClick={e => handleAcceptGeneralTerms()}>{intl.formatMessage({ id: 'common.generalTerms.button' })}
                </TextButton>
            </div>
        </div>
    </div>
})
